import { Grid, Typography } from "@mui/material";
import { ReportDto } from "interfaces/report";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { reportService } from "services/reportService";
import HeaderAction from "./components/HeaderAction";
import RevisionTable from "./components/RevisionTable";

export default function RevisionsPage() {
  const params = useParams();
  const [report, setReport] = useState<ReportDto>();

  useEffect(() => {
    (async () => {
      if (params.id) {
        const report = await reportService.getById(params.id);

        setReport(report);
      }
    })();
  }, [params.id]);

  return report ? (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <HeaderAction report={report} />
      </Grid>
      <Grid item xs={12}>
        <Typography>The following revisions have been made:</Typography>
      </Grid>
      <Grid item xs={12}>
        <RevisionTable report={report} />
      </Grid>
    </Grid>
  ) : (
    <></>
  );
}
